module.exports = __webpack_public_path__ + "img/34.79c30d5f.jpg";